var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.5 33.0002L3.5 18.0002L18.5 3.00024","stroke":"#52668C","strokeWidth":"5.08333","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronLeft.defaultProps = {"width":"22","height":"36","viewBox":"0 0 22 36","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
